import { ROLES_BY_ID, GROUPKEYS_BY_TYPE } from 'containers/User/constants.js';
import { idValues, makeIdObject } from 'utils/arrays.js';
import { makeUserIdObject } from 'utils/userIdRole.js';

const parseCustomPermissions = (o) => makeUserIdObject(o.map(adminParser));

export function customPermissionsReducer(state, action) {
  const { payload } = action;
  const roleList = idValues(payload);
  const result = parseCustomPermissions(roleList);
  return result;
}

function adminParser(obj) {
  const { group, user, ...rest } = obj;
  if (group || user) {
    return adminParser({ ...rest, ...group, ...user });
  }
  const result = {};
  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (value === null || value === undefined) {
      return;
    }
    switch (key) {
      case 'groups':
      case 'administrativeGroups':
        value = makeIdObject(value.map(adminParser));
        break;
      case 'owners':
        value = makeUserIdObject(value);
        break;
      case 'connections':
        value = makeIdObject(value);
        break;
      case 'roleType':
        result.typeName = ROLES_BY_ID[value];
        break;
      case 'groupType':
        result.typeName = GROUPKEYS_BY_TYPE[value];
        break;
      default:
        if (value.customPermissions) {
          value.customPermissions = parseCustomPermissions(value.customPermissions);
        }
    }
    result[key] = value;
  });
  return result;
}

export default adminParser;
